import React, { useEffect, useRef, useState } from "react";
import {
  get_particular_user,
  update_user,
  upload_image,
  upload_sell_item_logal_docs,
} from "../../reduxData/user/userAction";
import { useNavigate, useParams } from "react-router-dom";
import {
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import PhoneNo from "../../Shared/PhoneNo";
import { useDispatch, useSelector } from "react-redux";
import StorePhoneno from "../../Shared/StorePhoneno";
import FormControl from "@mui/joy/FormControl";
import Input from "@mui/joy/Input";
import { FormHelperText } from "@mui/joy";
import PdfImg from "../../images/pdficon.png";
import DocImg from "../../images/DocxIcon.png";
import { toast } from "react-toastify";
import DefaultImg from "../../images/no_profile.png";
import { useTranslation } from "react-i18next";
const { REACT_APP_BASE_URL, REACT_APP_IMAGE_URL } = process.env;

const AddEditUserManagement = () => {
  const emailRegex =
    /^(?!.*\.\.)(?!.*-@)(?!.*#)([A-Z0-9._%+-]+)@([A-Z0-9.-]+\.[A-Z]{2,})$/i;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userPermissions } = useSelector(state => state.auth);
  const [imgPreview, setimgPreview] = useState("");
  const imageRef = useRef();
  const [isStore, setIsStore] = useState(false);
  const [storeCountry, setStoreCountry] = useState("NL");
  const [ownerCountry, setOwnerCountry] = useState("NL");
  const [isSubmitDisable, setIsSubmitDisable] = useState(false);
  const [isData, setIsData] = useState(false);
  const [documentUpload, setDocumentUpload] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [docLoad, setDocLoad] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    dateOfJoining: "",
    email: "",
    phone_number: "",
    isDeactive: "Deactivate",
    user_name: "",
    kyc_no: "",
    location: "",
    store_name: "",
  });
  const [sellItem, setSellItem] = useState({
    owner_full_name: "",
    owner_phone_number: "",
    owner_email: "",
    additional_fees: "",
    store_name: "",
    store_website: "",
    store_email: "",
    store_phone_number: "",
    range: "",
    legal_doc: "",
    owner_country: "United States",
    owner_state: "Alabama",
  });
  const [errors, setErrors] = useState({
    name: "",
    phone_number: "",
    owner_email: "",
    additional_fees: "",
    store_name: "",
    store_website: "",
    store_email: "",
    store_phone_number: "",
    range: "",
    legal_doc: "",
    owner_full_name: "",
    owner_phone_number: "",
    kyc_no: "",
    location: "",
    user_name: "",
  });
  const [country, setCountry] = useState("NL");
  const step_one = {
    owner_full_name: sellItem?.owner_full_name, // Store
    owner_phone_number: sellItem?.owner_phone_number,
    owner_email: sellItem?.owner_email,
    additional_fees: sellItem?.additional_fees,
    store_name: sellItem?.store_name,
    store_website: sellItem?.store_website,
    range: sellItem?.range,
    legal_doc: sellItem?.legal_doc,
    store_email: sellItem?.store_email,
    store_phone_number: sellItem?.store_phone_number,
  };
  const [isImgEdit, setIsImgEdit] = useState(false);
  const [removePhotos, setRemovePhotos] = useState([]);
  const [removeFiles, setRemoveFiles] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  let maxSize = 40 * 1024 * 1024;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await get_particular_user(id, dispatch);
        setUserDetails(data);
        setFormData({
          dateOfJoining: data.created_at || "",
          email: data.email || "",
          phone_number: data.phone_no || "",
          user_name: data?.user_name || "",
          isDeactive: data.isDeactive ? "Deactivate" : "Active",
          profile_pic: data?.profile_pic || null,
          kyc_no: data?.kyc_no || "",
          location: data?.location || "",
          store_name: data?.store_name || "",
        });
        setCountry(data?.country_code_name ? data?.country_code_name : "NL");
        setSellItem(data?.store_info ? data?.store_info : sellItem);
        setIsStore(data?.store_info_status ? true : false);
        setOwnerCountry(
          data?.store_info && data?.store_info?.owner_number_name
            ? data?.store_info?.owner_number_name
            : "NL"
        );
        setStoreCountry(
          data?.store_info && data?.store_info?.store_number_name
            ? data?.store_info?.store_number_name
            : "NL"
        );
        setDocumentUpload(data?.store_info ? data?.store_info?.legal_doc : []);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    let errorMessage = "";
    switch (name) {
      case "user_name":
        errorMessage = !value.trim() ? t("addEditUser.userNameRequired") : "";
        break;
      case "kyc_no":
        errorMessage = !value.trim() ? t("addEditUser.kvkNumberRequired") : "";
        break;
      case "location":
        errorMessage = !value.trim() ? t("addEditUser.locationRequired") : "";
        break;
      case "store_name":
        errorMessage = !value.trim() ? t("addEditUser.storeNameRequired") : "";
        break;
      default:
        errorMessage = "";
        break;
    }

    setErrors({ ...errors, [name]: errorMessage });
    setFormData({ ...formData, [name]: name === "kyc_no" ? value.toUpperCase() : value });
  };

  const handleImage = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append(`photos`, e.target.files[0]);
    formData.append("type", "profile_pic");
    const res = await upload_image(formData, dispatch);
    if (res) {
      setFormData({
        ...formData,
        profile_pic: res?.path[0],
      });
      setimgPreview(URL.createObjectURL(e.target.files[0]));
      setIsImgEdit(true);
    }
  };

  const handlePhone = (value, fieldName) => {
    switch (fieldName) {
      case "phone_number":
        let countrycode = getCountryCallingCode(country);
        let checkvalue = `+${countrycode}${value}`;
        setErrors({
          ...errors,
          phone_number:
            value === ""
              ? t("addEditUser.phoneNumberRequired")
              : !isValidPhoneNumber(checkvalue)
                ? t("addEditUser.phoneNumberInvalid")
                : "",
        });
        setFormData({ ...formData, phone_number: value });
        break;
      default:
        break;
    }
  };

  const handleElementChange = async (value, label) => {
    setIsSubmitDisable(false);
    setIsData(true);
    let ownercountrycode = getCountryCallingCode(ownerCountry);
    let storecountrycode = getCountryCallingCode(storeCountry);
    const exptest =
      /^(?!.*\.\.)(?!.*-@)(?!.*#)([A-Z0-9._%+-]+)@([A-Z0-9.-]+\.[A-Z]{2,})$/i;
    const invalidPatterns = /http|www|co|in/i;

    if (label === "legal_doc") {
      const newDocs = Array.from(value);
      if (handleFileValidator(newDocs)) return;

      setDocLoad(true);
      const docsData = await upload_sell_item_logal_docs(
        newDocs,
        dispatch
      );
      setDocumentUpload((prev) => [...prev, ...docsData?.data?.path]);
      setSellItem((prev) => ({ ...prev, [label]: docsData?.data?.path }));
      setDocLoad(false);
    } else {
      setSellItem((prev) => ({ ...prev, [label]: value }));
    }

    setErrors((prev) => ({
      ...prev,
      [label]:
        label === "owner_phone_number" && !value
          ? t("addEditUser.phoneRequired")
          : label === "owner_phone_number" &&
            !isValidPhoneNumber(`+${ownercountrycode}${value}`)
            ? t("addEditUser.phoneInvalid")
            : label === "store_phone_number" && !value
              ? t("addEditUser.phoneRequired")
              : label === "store_phone_number" &&
                !isValidPhoneNumber(`+${storecountrycode}${value}`)
                ? t("addEditUser.phoneInvalid")
                : label === "store_website" && value === ""
                  ? t("addEditUser.storeWebsiteRequired")
                  : label === "store_website" && !invalidPatterns.test(value)
                    ? t("addEditUser.storeWebsiteInvalid")
                    : label === "store_email" && value === ""
                      ? t("addEditUser.storeEmailRequired")
                      : label === "store_email" && !exptest.test(value)
                        ? t("addEditUser.storeEmailInvalid")
                        : label === "owner_email" && value === ""
                          ? t("addEditUser.ownerEmailRequired")
                          : label === "owner_email" && !exptest.test(value)
                            ? t("addEditUser.ownerEmailInvalid")
                            : value === "" &&
                              [
                                "additional_fees",
                                "range",
                                "store_name",
                                "owner_full_name",
                              ].includes(label)
                              ? "Required"
                              : "",
    }));
  };

  const handleRemoveDoc = (item) => {
    setRemoveFiles((prev) => [...prev, item]);
    let Docs = documentUpload.filter((itm) => itm !== item);
    setDocumentUpload([...Docs]);
    setSellItem((prev) => ({ ...prev, legal_doc: Docs }));
  };

  const handleFileValidator = (fileArray) => {
    let maxFileSize = fileArray?.filter((item) => item?.size > maxSize);
    if (maxFileSize?.length > 0) {
      toast.error(t("addEditUser.fileSizeError"), {
        toastId: "uploafileeeeerrr",
        autoClose: 2000,
      });
      return true;
    } else {
      return false;
    }
  };

  const checkAllErrors = (data) => {
    let err = false;
    let checkErrorData = data;
    let ownercountrycode = getCountryCallingCode(ownerCountry);
    let storecountrycode = getCountryCallingCode(storeCountry);
    let invalidPatterns = /http|www|co|in/i;

    let output = Object.entries(checkErrorData);
    output.forEach(async ([key, value]) => {
      if (
        typeof value === "string" &&
        !value?.trim() &&
        ["additional_fees", "range", "store_name", "owner_full_name"].includes(
          key
        )
      ) {
        err = true;
        setErrors((prevErrors) => ({ ...prevErrors, [key]: "Required" }));
      }
      if (key === "phone_number" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.phoneRequired"),
        }));
      }
      if (key === "owner_email" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.ownerEmailRequired"),
        }));
      }
      if (key === "store_email" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.storeEmailRequired"),
        }));
      }
      if (key === "store_phone_number" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.storePhoneRequired"),
        }));
      }
      if (key === "store_email" && value && !emailRegex.test(value)) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.storeEmailInvalid"),
        }));
      }
      if (key === "store_website" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.storeWebsiteRequired"),
        }));
      }
      if (key === "store_website" && value && !invalidPatterns.test(value)) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.storeWebsiteInvalid"),
        }));
      }
      if (key === "owner_email" && value && !emailRegex.test(value)) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.ownerEmailInvalid"),
        }));
      }
      if (key === "owner_phone_number" && value === "") {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.ownerPhoneRequired"),
        }));
      }
      if (key === "legal_doc" && value?.length === 0) {
        err = true;
        setErrors((prevErrors) => ({ ...prevErrors, [key]: "Required" }));
      }
      if (
        value &&
        key === "store_phone_number" &&
        !isValidPhoneNumber(`+${storecountrycode}${value}`)
      ) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.phoneInvalid"),
        }));
      }
      if (value && key === "owner_email" && !emailRegex.test(value)) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.ownerEmailInvalid"),
        }));
      }
      if (
        value &&
        key === "owner_phone_number" &&
        !isValidPhoneNumber(`+${ownercountrycode}${value}`)
      ) {
        err = true;
        setErrors((prevErrors) => ({
          ...prevErrors,
          [key]: t("addEditUser.phoneInvalid"),
        }));
      }
    });

    return err;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let countrycode = getCountryCallingCode(country);
    let checkvalue = `+${countrycode}${formData.phone_number}`;
    const validationErrors = {
      user_name: !formData.user_name.trim() ? t("addEditUser.userNameRequired") : "",
      phone_number: formData.phone_number === "" ? t("addEditUser.phoneRequired") : !isValidPhoneNumber(checkvalue) ? t("addEditUser.phoneInvalid") : "",
    };

    if (userDetails?.role === 'seller') {
      validationErrors.kyc_no = !formData.kyc_no.trim() ? t("addEditUser.kycNumberRequired") : "";
      validationErrors.location = !formData.location.trim() ? t("addEditUser.locationRequired") : "";
      validationErrors.store_name = !formData.store_name.trim() ? t("addEditUser.storeNameRequired") : "";
    }

    setErrors((prev) => ({ ...prev, ...validationErrors }));

    // Check if there are any errors in formData
    const hasFormErrors = Object.values(validationErrors).some(
      (error) => error !== ""
    );

    // Validate store-related fields if isStore is true
    let hasStoreErrors = false;
    if (isStore) {
      hasStoreErrors = checkAllErrors(step_one);
    }

    // Prevent submission if there are errors
    if (hasFormErrors || hasStoreErrors) {
      return;
    }

    let ownercountrycode = getCountryCallingCode(ownerCountry);
    let storecountrycode = getCountryCallingCode(storeCountry);

    const userdata = {
      user_name: formData?.user_name,
      email: formData?.email,
      phone_no: formData?.phone_number,
      country_code: `+${countrycode}`,
      country_code_name: country,
      store_name: formData?.store_name,
      kyc_no: formData?.kyc_no,
      location: formData?.location,
      is_deactive: userDetails?.is_deactive
    };

    try {
      const isEdit = await update_user(id, userdata, navigate, dispatch);
      if (isEdit) {
        // toast.success("User updated successfully!", {
        //   toastId: "updateSuccess",
        //   autoClose: 2000,
        // });
        setFormData({
          dateOfJoining: "",
          email: "",
          phone_number: "",
          user_name: "",
          store_name: "",
          kyc_no: "",
          location: "",
        });
        setErrors({
          name: "",
          phone_number: "",
          owner_email: "",
          additional_fees: "",
          store_name: "",
          store_website: "",
          store_email: "",
          store_phone_number: "",
          range: "",
          legal_doc: "",
          owner_full_name: "",
          owner_phone_number: "",
          kyc_no: "",
          location: "",
          user_name: "",
        });
      }
    } catch (error) {
      toast.error("Failed to update user. Please try again.", {
        toastId: "updateError",
        autoClose: 2000,
      });
    }
  };

  const changeDateFormat = (data) => {
    const dateObject = new Date(data);
    const year = dateObject.getFullYear();
    const month = ("0" + (dateObject.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObject.getDate()).slice(-2);
    const formattedDate = `${year}-${day}-${month}`;
    return formattedDate;
  };

  const docref = useRef();
  const handleDoc = () => {
    docref.current.click();
  };

  return (
    <div className="container profile-deatils">
      <h3 className="mt-3 mb-1 fw-600">{id ? t("addEditUser.editTitle") : t("addEditUser.addTitle")}</h3>
      <form onSubmit={handleSubmit} className="row mt-4">
        <div className="col-12 mb-3">
          <input
            type="file"
            name="profile_pic"
            className="d-none"
            accept="image/png, image/jpeg, image/jpg, image/gif"
            ref={imageRef}
            onChange={(e) => handleImage(e)}
          />
          {imgPreview ? (
            <img
              src={imgPreview}
              style={{ width: 70, height: 70, borderRadius: 75 }}
              className="object-fit-cover"
            />
          ) : (
            <img
              src={
                formData?.profile_pic ? `${REACT_APP_IMAGE_URL}${formData?.profile_pic}` : DefaultImg
              }
              style={{ width: 100, height: 100, borderRadius: 75, border: '2px solid #ddd' }}
              className="object-fit-cover "
            />
          )}
        </div>
        <div className="mb-3 col-md-6 position-relative">
          <label className="form-label fw-600">{t("addEditUser.userNameLabel")} <span className="requiredstar">*</span></label>
          <input
            type="text"
            className="form-control"
            name="user_name"
            value={formData.user_name}
            onChange={handleChange}
          />
          {errors?.user_name && (
            <div className="error_msg">{errors.user_name}</div>
          )}
        </div>
        <div className="mb-3 col-md-6">
          <label htmlFor="email" className="form-label fw-600">
            {t("addEditUser.emailLabel")}
          </label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            disabled
            onChange={handleChange}
          />
        </div>
        <div className="mb-3 col-md-6">
          <label htmlFor="dateOfJoining" className="form-label fw-600">
            {t("addEditUser.dateOfJoiningLabel")}
          </label>
          <input
            type="text"
            className="form-control"
            id="dateOfJoining"
            name="dateOfJoining"
            value={changeDateFormat(formData.dateOfJoining)}
            onChange={handleChange}
            disabled
          />
        </div>
        <div className="mb-3 col-md-6 position-relative">
          <label htmlFor="phone_number" className="form-label fw-600">
            {t("addEditUser.phoneNumberLabel")} <span className="requiredstar">*</span>
          </label>
          <PhoneNo
            sellItem={formData?.phone_number}
            setSellItem={() => setFormData({ ...formData, phone_number: "" })}
            handlePhone={handlePhone}
            country={country}
            setCountry={(value) => setCountry(value)}
          />
          {errors?.phone_number && (
            <div className="error_msg">{errors.phone_number}</div>
          )}
        </div>
        {(userDetails && userDetails?.role === 'seller') && <div className="mb-3 col-md-6 position-relative">
          <label className="form-label fw-600">{t("addEditUser.storeNameLabel")} <span className="requiredstar">*</span></label>
          <input
            type="text"
            className="form-control"
            name="store_name"
            value={formData.store_name}
            onChange={handleChange}
          />
          {errors?.store_name && (
            <div className="error_msg">{errors.store_name}</div>
          )}
        </div>}
        {(userDetails && userDetails?.role === 'seller') && <div className="mb-3 col-md-6 position-relative">
          <label className="form-label fw-600">{t("addEditUser.kvkNumberLabel")} <span className="requiredstar">*</span></label>
          <input
            type="text"
            className="form-control"
            name="kyc_no"
            value={formData.kyc_no}
            onChange={handleChange}
          />
          {errors?.kyc_no && (
            <div className="error_msg">{errors.kyc_no}</div>
          )}
        </div>}
        {(userDetails && userDetails?.role === 'seller') && <div className="mb-3 col-md-6 position-relative">
          <label className="form-label fw-600">{t("addEditUser.locationLabel")} <span className="requiredstar">*</span></label>
          <input
            type="text"
            className="form-control"
            name="location"
            value={formData.location}
            onChange={handleChange}
          />
          {errors?.location && (
            <div className="error_msg">{errors?.location}</div>
          )}
        </div>}
        {(userDetails && userDetails?.role === 'seller') && <div className="mb-3 col-md-6">
          <label className="form-label fw-600">{t("addEditUser.saleTypeLabel")}</label>
          <input
            type="text"
            className="form-control"
            name="promoted"
            value={!userDetails?.promoted ? '7% Anonymous Sale' : '10% Promoted Sale'}
            disabled
          />
        </div>}
        {(userDetails && userDetails?.role === 'seller' && userDetails?.promoted) &&
          <><div className="mb-3 col-md-12 d-flex flex-column">
            <label className="form-label fw-600">{t("addEditUser.companyLogoLabel")}</label>
            <img
              src={
                userDetails?.company_logo ? `${REACT_APP_IMAGE_URL}${userDetails?.company_logo}` : DefaultImg
              }
              style={{ width: 100, height: 100, borderRadius: 75, border: '2px solid #ddd' }}
              className="object-fit-cover "
            />
          </div>
            <div className="mb-3 col-md-12">
              <label className="form-label fw-600">{t("addEditUser.bioLabel")}</label>
              <div className="password position-relative">
                <textarea
                  name="notes"
                  cols="4"
                  rows="4"
                  class="form-control b-0 text-area-height"
                  placeholder={t("addEditUser.bioPlaceholder")}
                  style={{ height: '120px' }}
                  value={userDetails?.bio}
                ></textarea>
              </div>
            </div>
          </>
        }
        {userPermissions?.users?.edit && (<div className="d-flex gap-3 mb-3 col-md-12">
          <button type="submit" className="btn common-button">
            {t("addEditUser.submitButton")}
          </button>
          <button
            className="btn common-button back-btn"
            onClick={() => navigate("/users")}
          >
            {t("addEditUser.cancelButton")}
          </button>
        </div>)}

      </form>
    </div>
  );
};

export default AddEditUserManagement;